import React, { Component } from 'react';

export default class Modal extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        // validate if the props changes
        if(prevProps.show != this.props.show) {
            $(this.refs.modal).modal(this.props.show ? 'show': 'hide');
        }
    }

    render() {
        const { serie, folio, onXML, onPDF, onCloseModal } = this.props;

        return (
            <div className="modal" tabIndex="-1" role="dialog" ref="modal">
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Factura Generada Exitosamente</h5>
                          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onCloseModal}>
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <p>Número de Serie: {serie}</p>
                          <p>Número de Folio: {folio}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-custom-theme" onClick={onXML}>
                                <i className="fas fa-file-alt"></i> XML
                            </button>
                            <button type="button" className="btn btn-custom-theme" onClick={onPDF}>
                                 <i className="fas fa-file-pdf"></i> PDF
                            </button>
                        </div>
                      </div>
                    </div>
                </div>
        )
    }

}



// WEBPACK FOOTER //
// ./Public/src/js/util/modal/index.jsx